/* unplugin-vue-components disabled */import { render } from "./tenant-general.vue?vue&type=template&id=172c7150&scoped=true"
import script from "./tenant-general.vue?vue&type=script&lang=js"
export * from "./tenant-general.vue?vue&type=script&lang=js"

import "./tenant-general.vue?vue&type=style&index=0&id=172c7150&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172c7150"],['__file',"src/pages/tenant/settings/tenant-general.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "172c7150"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('172c7150', __exports__)) {
    api.reload('172c7150', __exports__)
  }
  
  module.hot.accept("./tenant-general.vue?vue&type=template&id=172c7150&scoped=true", () => {
    api.rerender('172c7150', render)
  })

}


export default __exports__